import { render, staticRenderFns } from "./pchome.vue?vue&type=template&id=17361f54"
import script from "./pchome.vue?vue&type=script&lang=js"
export * from "./pchome.vue?vue&type=script&lang=js"
import style0 from "./pchome.vue?vue&type=style&index=0&id=17361f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports